// Modules
import React from 'react'

// Application
import { NAC_CONTACTS } from 'constants/NACContacts'

export const PhonesHelpCenter: React.FC = () => (
    <>
        <a href="https://api.whatsapp.com/send/?phone=551140202117" rel="noreferrer" target="_blank">
            {NAC_CONTACTS.PHONE}
        </a>
    </>
)
